import { Stack, Flex, createStyles } from '@mantine/core';
import type { StackProps } from '@mantine/core';

import { createQueryString } from '~/domains/common/utils/queryString';

import { FacebookIcon, GoogleIcon, AppleIcon } from './SSOButtonIcons';

export function SSOButtons({ children, ...props }: StackProps) {
  const { classes } = useStyles();
  return (
    <Flex gap={16} sx={{ overflow: 'visible' }} className={classes.SSOButtonsContainer} {...props}>
      {children}
    </Flex>
  );
}

const SSO_URLS = {
  GOOGLE: `${process.env.NEXT_PUBLIC_API_URL_RYP}auth/google`,
  FACEBOOK: `${process.env.NEXT_PUBLIC_API_URL_RYP}auth/facebook`,
  APPLE: `${process.env.NEXT_PUBLIC_API_URL_RYP}auth/apple`,
};

// @todo - verify to reset password url
const redirectUri = `${process.env.NEXT_PUBLIC_URL || 'https://local.splashsports.com/'}/account/forgot-password?brand=RYP`;

const useStyles = createStyles((theme) => ({
  SSOButtonsContainer: {
    maxWidth: 420,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  SSOButton: {
    display: 'flex',
    maxWidth: 129,
    height: 48,
    borderRadius: theme.radius.md,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: theme.other.spacing._12,
    '&:hover': {
      cursor: 'pointer',
      opacity: '0.7',
    },
  },
  SSOButtonIcon: {
    paddingTop: theme.other.spacing._6,
  },
}));

export function FacebookLink() {
  const { classes } = useStyles();

  return (
    <Stack
      p={0}
      w="100%"
      sx={{ overflow: 'visible', backgroundColor: '#3872DC' }}
      className={classes.SSOButton}
      onClick={() => {
        window.location.href = `${SSO_URLS.FACEBOOK}${createQueryString({ provider: 'Facebook', redirectUri })}`;
      }}
    >
      <div className={classes.SSOButtonIcon}>
        <FacebookIcon size={24} />
      </div>
    </Stack>
  );
}

export function GoogleLink() {
  const { classes } = useStyles();

  return (
    <Stack
      p={0}
      w="100%"
      sx={{ overflow: 'visible', backgroundColor: '#DB4437' }}
      className={classes.SSOButton}
      onClick={() => {
        window.location.href = `${SSO_URLS.GOOGLE}${createQueryString({ provider: 'Google', redirectUri })}`;
      }}
    >
      <div className={classes.SSOButtonIcon}>
        <GoogleIcon size={24} />
      </div>
    </Stack>
  );
}

export function AppleLink() {
  const { classes } = useStyles();
  return (
    <Stack
      p={0}
      w="100%"
      sx={{ overflow: 'visible', backgroundColor: '#1A1C1E' }}
      className={classes.SSOButton}
      onClick={() => {
        window.location.href = `${SSO_URLS.APPLE}${createQueryString({ provider: 'Apple', redirectUri })}`;
      }}
    >
      <div className={classes.SSOButtonIcon}>
        <AppleIcon size={24} />
      </div>
    </Stack>
  );
}

export { SSOButtons as OauthSSO };

SSOButtons.Facebook = FacebookLink;
SSOButtons.Google = GoogleLink;
SSOButtons.Apple = AppleLink;
